<template >
  <!-- 停水事件新增 -->
  <a-modal :title="title" width="50%" v-model="addOrUpdateVisible" :destroyOnClose="true" @cancel="handleCancel">
    <template #footer>
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleOk" :disabled="disabled">确定</a-button>
    </template>
    <a-form-model
      class="log-form"
      :model="gisWaterEvent"
      ref="gisWaterEvent"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 14 }"
    >
      <a-row class="form-row" type="flex" justify="center" :gutter="4">
        <a-col :md="24" :sm="24">
          <a-form-model-item label="事件编号" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
            <span v-if="!gisWaterEvent.eventNo">(系统自动生成)</span>
            <span v-else>{{ gisWaterEvent.eventNo }}</span>
          </a-form-model-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-form-model-item label="事件名称" prop="eventName" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
            <a-input v-model="gisWaterEvent.eventName" />
          </a-form-model-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-form-model-item label="管段信息" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
            <a-button type="primary" @click="openMap">点击选择管道</a-button>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="开始分类编码" prop="startClassNo">
            <a-input v-model="gisWaterEvent.startClassNo" disabled />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="结束分类编码" prop="endClassNo">
            <a-input v-model="gisWaterEvent.endClassNo" disabled />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="计划停水开始时间"
            prop="startValue"
            :label-col="{ span: 9 }"
            :wrapper-col="{ span: 15 }"
          >
            <a-date-picker
              v-model="gisWaterEvent.startValue"
              :disabled-date="disabledStartDate"
              @change="onChanges"
              style="width: 149px"
              format="YYYY-MM-DD HH:mm:ss"
              @openChange="handleStartOpenChange"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="计划停水结束时间"
            prop="endValue"
            :label-col="{ span: 9 }"
            :wrapper-col="{ span: 15 }"
          >
            <a-date-picker
              v-model="gisWaterEvent.endValue"
              :disabled-date="disabledEndDate"
              format="YYYY-MM-DD HH:mm:ss"
              style="width: 149px"
              :open="endOpen"
              @change="onChanget"
              @openChange="handleEndOpenChange"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="事件管理员" prop="adminId">
            <a-select show-search style="width: 200px" v-model="gisWaterEvent.adminId">
              <a-select-option v-for="item in userlist" :key="item.id">{{ item.realName }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="事件负责人" prop="principalId">
            <a-select show-search style="width: 200px" v-model="gisWaterEvent.principalId">
              <a-select-option v-for="item in userlist" :key="item.id">{{ item.realName }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-form-model-item
            label="停水管理员"
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 20 }"
            prop="waterAdminId"
          >
            <a-select show-search v-model="gisWaterEvent.waterAdminId">
              <a-select-option v-for="item in userlistht" :key="item.id">{{ item.realName }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-form-model-item label="描述" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" prop="describe">
            <a-textarea placeholder="多行输入" v-model="gisWaterEvent.describe" :rows="2" />
          </a-form-model-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-form-model-item label="附件上传" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
            <a-upload-dragger name="file" :multiple="true" :customRequest="customReques" :showUploadList="false">
              <p class="ant-upload-drag-icon">
                <a-icon type="inbox" />
              </p>
              <p class="ant-upload-text">
                文件拖拽此处或
                <a>点击上传</a>
              </p>
            </a-upload-dragger>
            <div class="fileDiv">
              <ul>
                <li class="fileLi" v-for="item in gisWaterEvent.fileNames" :key="item.url">
                  <div class="uploadDiv" @click="uploadFile(item)">
                    <a-icon type="file-done" style="cursor: pointer" />
                    {{ item.name }}
                  </div>
                  <a-icon type="delete" style="float: right; cursor: pointer" @click="deleteFile(item.url)" />
                </li>
              </ul>
            </div>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <a-modal class="log-form" :title="'选取位置'" width="50%" v-model="showMap" @ok="closeMap" @cancel="closeMap2">
      <input class="login-input" type="text" v-model="startLine" placeholder="请输入开始分类编码" />
      <input class="login-input" type="text" v-model="endLine" placeholder="请输入结束分类编码" />
      <a-button type="submit" @click="searchMapLine">查询</a-button>
      <mapTemplate ref="waterMap" v-on:childByValue="childByValue"></mapTemplate>
    </a-modal>
  </a-modal>
</template>

<script>
import dayjs from 'dayjs'
import mapTemplate from '@/views/Water-outage-control/map-template.vue'
export default {
  components: {
    dayjs,
    mapTemplate,
  },
  data() {
    return {
      currentId: '',
      uploadUrl: 'manager/file/resources/upload', // 上传文件URL
      queryOneUrl: '/pipe-network/gis_water_events/',
      addOrUpdateUrl: '/pipe-network/gis_water_events',
      isUpdate: false,
      endOpen: false,
      showMap: false,
      userlist: [],
      userlistht: [],
      confirmLoading: false,
      addOrUpdateVisible: false,
      disabled: false,
      list: [],
      startLine: '',
      endLine: '',
      title: '新增',
      zoneTreeData: [], // 分区数据选项
      childValue: {},
      gisWaterEvent: {
        eventNo: '',
        eventName: '',
        startClassNo: '',
        endClassNo: '',
        endValue: '',
        startValue: '',
        describe: '',
        planEntTime: '',
        waterAdminName: '',
        planStartTime: '',
        fileNames: [],
        adminId: '',
        principalId: '',
        waterAdminId: '',
        source: '工程管理系统',
        lineId: '',
      },
      DetailsData: {},
    }
  },
  computed: {
    rules() {
      return {
        eventName: [{ required: true, message: '请输入事件名称', trigger: 'change' }],
        describe: [{ required: true, message: '请输入描述', trigger: 'change' }],
        startValue: [{ required: true, message: '请选择计划停水开始时间', trigger: 'change' }],
        endValue: [{ required: true, message: '请选择计划停水结束时间', trigger: 'change' }],
        principalId: [{ required: true, message: '请选择事件负责人', trigger: 'change' }],
        adminId: [{ required: true, message: '请选择事件管理员', trigger: 'change' }],
        waterAdminId: [{ required: true, message: '请选择停水管理员', trigger: 'change' }],
        startClassNo: [{ required: true, message: '请输入开始分类编码', trigger: 'change' }],
        endClassNo: [{ required: true, message: '请输入结束分类编码', trigger: 'change' }],
      }
    },
  },
  created() {},
  mounted() {},
  methods: {
    childByValue(childValue) {
      this.startLine = childValue[0].properties.start_class_no
      this.endLine = childValue[0].properties.end_class_no 
      this.gisWaterEvent.lineId = childValue[0].id.substr(childValue[0].id.lastIndexOf('.') + 1, 20)
    },
    openMap() {
      this.showMap = true
      this.$refs.waterMap.redSource.clear()
      this.startLine = this.gisWaterEvent.startClassNo || ''
      this.endLine = this.gisWaterEvent.endClassNo || ''
      if (this.startLine.length > 0 || this.endLine.length > 0) {
        this.$nextTick(() => {
          this.$refs.waterMap.searchLines(this.startLine, this.endLine)
        })
      }
    },
    closeMap() {
      this.gisWaterEvent.endClassNo = this.endLine
      this.gisWaterEvent.startClassNo = this.startLine
      this.startLine = ''
      this.endLine = ''
      this.showMap = false
      this.$refs.waterMap.redSource.clear()
    },
    closeMap2() {
      this.showMap = false
      this.startLine = ''
      this.endLine = ''
      this.$refs.waterMap.redSource.clear()
    },
    searchMapLine() {
      this.$refs.waterMap.searchLines(this.startLine, this.endLine)
    },
    ReassignHandle() {
      this.title = '新增'
      this.disabled = false
      this.addOrUpdateVisible = true
      this.getUserList()
    },
    getUserList() {
      this.$http.get('/manager/users/list').then(({ data }) => {
        this.userlist = data
        this.userlistht = data
      })
    },
    //时间
    disabledStartDate(current) {
      return current && current < dayjs().endOf('day')
    },
    disabledEndDate(endValue) {
      const startValue = this.gisWaterEvent.startValue
      if (!endValue || !startValue) {
        return false
      }
      return startValue.valueOf() >= endValue.valueOf()
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open
    },
    onChanges(value, dateString) {
      this.gisWaterEvent.planStartTime = dateString
    },
    onChanget(value, dateString) {
      this.gisWaterEvent.planEntTime = dateString
    },

    handleOk(e) {
      console.log('lllll')
      e.preventDefault()
      this.$refs.gisWaterEvent.validate((valid) => {
        if (valid) {
          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, {
            id: this.currentId,
            ...this.gisWaterEvent,
          })
            .then((res) => {
              if (res.code === 0) {
                if (this.currentId == '') {
                  this.childValue = res.data
                  console.log(this.currentId, 'jjj')
                } else {
                  this.childValue = {}
                }

                this.$emit('childByValue', this.childValue)
                this.$refs.gisWaterEvent.resetFields()
                this.addOrUpdateVisible = false
                this.gisWaterEvent.waterAdminName = ''
                this.gisWaterEvent.fileNames = []
                this.gisWaterEvent.eventNo = ''
                this.gisWaterEvent.endClassNo = ''
                this.gisWaterEvent.startClassNo = ''
                return this.$message.success(res.message)
              }
            })
            .catch(() => {})
        }
      })
    },

    CheckUpdateHandle(id) {
      this.title = '查看'
      this.disabled = true
      this.getUserList()
      this.isUpdate = false
      this.currentId = id
      this.addOrUpdateVisible = true
      if (id) {
        this.$nextTick(() => {
          this.$refs.gisWaterEvent.resetFields()
          if (id) {
            this.isUpdate = true
            this.$http
              .get(`${this.queryOneUrl}/${this.currentId}`)
              .then(({ data }) => {
                this.gisWaterEvent = {
                  eventNo: data.eventNo,
                  eventName: data.eventName,
                  startClassNo: data.startClassNo,
                  endClassNo: data.endClassNo,
                  endValue: data.planEntTime,
                  startValue: data.planStartTime,
                  planEntTime: data.planEntTime,
                  planStartTime: data.planStartTime,
                  describe: data.describe,
                  planEntTime: data.planEntTime,
                  waterAdminName: data.waterAdminName,
                  fileNames: data.fileNames,
                  adminId: data.adminId,
                  principalId: data.principalId,
                  waterAdminId: data.waterAdminId,
                }
              })
              .catch(() => {})
          }
        })
      }
    },
    //取消
    handleCancel(e) {
      this.visible = false
      this.addOrUpdateVisible = false
      this.$refs.gisWaterEvent.resetFields()
      this.gisWaterEvent.waterAdminName = ''
      this.gisWaterEvent.fileNames = []
      this.gisWaterEvent.eventNo = ''
      this.gisWaterEvent.endClassNo = ''
      this.gisWaterEvent.startClassNo = ''
    },
    customReques(data) {
      // 上传提交
      const formData = new FormData()
      formData.append('file', data.file)
      this.saveFile(formData)
    },
    saveFile(formData) {
      this.importLoading = true
      this.axios({
        method: 'post',
        url: this.uploadUrl,
        headers: {},
        params: {},
        data: formData,
      })
        .then((response) => {
          if (response.code === 0) {
            let obj = {
              url: response.data.url,
              name: response.data.fileName,
            }
            this.gisWaterEvent.fileNames.push(obj)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
        .finally(() => {
          this.importLoading = false
        })
    },
    uploadFile(item) {
      const link = document.createElement('a') // 创建a标签
      link.download = item.name // a标签添加属性
      link.style.display = 'none'
      link.href = item.url
      document.body.appendChild(link)
      link.click() // 执行下载
      document.body.removeChild(link) // 释放标签
    },
    deleteFile(url) {
      let index = this.gisWaterEvent.fileNames.findIndex((item) => {
        return item.url == url
      })
      console.log(index)
      this.gisWaterEvent.fileNames.splice(index, 1)
    },
  },
}
</script>

<style lang="less" scoped>
</style>
